/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateNoteIndex } from '../../axios/candidateNoteIndex'
import type {
	CandidateNoteIndexError,
	CandidateNoteIndexPathParams,
	CandidateNoteIndexResponse,
} from '../../types/CandidateNoteIndex'

export const candidateNoteIndexQueryKey = (candidate: CandidateNoteIndexPathParams['candidate']) =>
	[{ url: '/candidates/:candidate/notes', params: { candidate } }] as const

export type CandidateNoteIndexQueryKey = ReturnType<typeof candidateNoteIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::index */
export function candidateNoteIndexQueryOptions(
	candidate: CandidateNoteIndexPathParams['candidate'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidateNoteIndexResponse,
		AxiosError<CandidateNoteIndexError>,
		CandidateNoteIndexResponse,
		CandidateNoteIndexQueryKey
	>({
		queryKey: candidateNoteIndexQueryKey(candidate),
		queryFn: ({ signal }) => candidateNoteIndex(candidate, { signal, ...config }).then(res => res.data),
		enabled: !!candidate,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::index */
export function useCandidateNoteIndex<TSelectData = CandidateNoteIndexResponse>(
	candidate: CandidateNoteIndexPathParams['candidate'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidateNoteIndexResponse,
					AxiosError<CandidateNoteIndexError>,
					TSelectData,
					CandidateNoteIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidateNoteIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidateNoteIndexQueryOptions(candidate),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::index */
export function useCandidateNoteIndexSuspense<TSelectData = CandidateNoteIndexResponse>(
	candidate: CandidateNoteIndexPathParams['candidate'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidateNoteIndexResponse,
					AxiosError<CandidateNoteIndexError>,
					TSelectData,
					CandidateNoteIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidateNoteIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidateNoteIndexQueryOptions(candidate),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
